module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("User Management")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar User")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("User Management")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan kata kunci dan tekan enter"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadUserData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "height": "34px",
      "padding": "5px 15px 5px 15px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(1)
      }
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "height": "34px",
      "padding": "5px 15px 5px 15px",
      "font-size": "11px",
      "margin": "0px 10px 0px 10px"
    },
    on: {
      "click": function($event) {
        return _vm.showFilter()
      }
    }
  }, [_vm._v("Filter")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n            FILTER : \n              "), _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("\n                Order: " + _vm._s(this.filter.order) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("\n                Order By: " + _vm._s(this.filter.orderby) + "\n              ")]), _vm._v(" "), (_vm.filter.grade !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('grade')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                Kelas: " + _vm._s(this.filter.grade) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.filter.npsn !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('npsn')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                NPSN: " + _vm._s(this.filter.npsn) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.filter.type !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('type')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                Jenis Sekolah: " + _vm._s(this.filter.type) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(row, key) {
    return _c('tr', {
      key: key,
      on: {
        "dblclick": function($event) {
          return _vm.goToDetail(key)
        }
      }
    }, [_c('td', [_vm._v(_vm._s((25 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.email.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.phone_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.school ? row.school.toUpperCase() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.grade))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          return _vm.showChangePassword(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageNumber),
      expression: "pageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pageNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pageNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalFilter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "300px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.order),
      expression: "filter.order"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "order", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Order By")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.orderby),
      expression: "filter.orderby"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "orderby", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("Nama")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.grade),
      expression: "filter.grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "grade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._l(([4, 5, 6, 7, 8, 9, 10, 11, 12]), function(i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("Kelas " + _vm._s(i))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Kelas")])], 2)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("NPSN")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.npsn),
      expression: "filter.npsn"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "npsn", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NOT_NULL"
    }
  }, [_vm._v("Ada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NULL"
    }
  }, [_vm._v("Tidak Ada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Jenis Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.type),
      expression: "filter.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FORMAL"
    }
  }, [_vm._v("Formal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INFORMAL"
    }
  }, [_vm._v("Informal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua")])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_vm._v("Aktifkan Filter")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalChangepassword",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "300px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Anda akan mengubah password untuk ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.userData.name + ' - ' + _vm.userData.email))])]), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Masukkan password baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [((_vm.seeNewPass ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPassword) ? _vm._i(_vm.newPassword, null) > -1 : (_vm.newPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newPassword = $$c
        }
      }
    }
  }) : ((_vm.seeNewPass ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPassword, null)
    },
    on: {
      "change": function($event) {
        _vm.newPassword = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": _vm.seeNewPass ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(!_vm.seeNewPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeNewPass = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e(), _vm._v(" "), (_vm.seeNewPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeNewPass = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Konfirmasi password baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [((_vm.seeConfirmPass ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirmPassword) ? _vm._i(_vm.confirmPassword, null) > -1 : (_vm.confirmPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirmPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirmPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirmPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirmPassword = $$c
        }
      }
    }
  }) : ((_vm.seeConfirmPass ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.confirmPassword, null)
    },
    on: {
      "change": function($event) {
        _vm.confirmPassword = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": _vm.seeConfirmPass ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(!_vm.seeConfirmPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeConfirmPass = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e(), _vm._v(" "), (_vm.seeConfirmPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeConfirmPass = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitChangePassword()
      }
    }
  }, [_vm._v("Ubah Password")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar User\n          ")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Phone Number")]), _vm._v(" "), _c('th', [_vm._v("School")]), _vm._v(" "), _c('th', [_vm._v("Kelas")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Filter Data User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah password user")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3122f6d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/usman/UserManagement.vue
// module id = 1315
// module chunks = 0